var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{staticClass:"pointer",style:(!_vm.selected
      ? { 'border-radius': '4px', border: '1px solid', color: _vm.item.color, 'background-color': this.setTransparencyHex(_vm.item.color, 0.15), 'border-color': _vm.item.color, margin: '1px 4px 3px 1px' }
      : {
          color: _vm.item.color,
          'background-color': _vm.isButton ? _vm.item.color : _vm.setTransparencyHex(_vm.item.color, 1),
          'border-color': _vm.isButton ? _vm.item.color : _vm.setTransparencyHex(_vm.item.color, 1),
          margin: '1px 4px 3px 1px',
          'border-radius': '4px',
          color: '#fff'
        }),attrs:{"size":_vm.size?_vm.size: 'small',"effect":"dark"}},[(_vm.isButton && _vm.selected)?_c('div',{staticClass:"font-size-11 fw-semibold text-center text-white",staticStyle:{"border-radius":"2px"}},[_vm._v(" "+_vm._s(_vm.item.name)+" ")]):_c('div',{staticClass:"font-size-11 fw-semibold text-center",staticStyle:{"border-radius":"2px"}},[_vm._v(_vm._s(_vm.item.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }